const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'

const HOST = HOSTNAME!.split('staging.')
const DOMAIN = HOST[HOST.length - 1]
const DOMAIN_NO_B2B = DOMAIN.split('b2b.')
const DOMAIN_PUBLIC = DOMAIN_NO_B2B[DOMAIN_NO_B2B.length - 1]
const getDomain = (domain?: string): string => DEV ? 'localhost' : domain ? domain : `.${DOMAIN_PUBLIC}`

interface iCookieSerializeOptions {
  domain?: string
  encode?(value: string): string
  expires?: Date
  httpOnly?: boolean
  maxAge?: number
  path?: string
  sameSite?: true | false | 'lax' | 'strict' | 'none'
  secure?: boolean
}

export const cookie = {
  set: (name: string, value: string = '', options: iCookieSerializeOptions = {}): void => {
    const { domain, expires, httpOnly, maxAge, path, sameSite } = options
    let cookieString = `${name}=${value}`

    cookieString += `; domain=${getDomain(domain)}`
    if (expires) cookieString += `; expires=${expires.toUTCString()}`
    if (httpOnly) cookieString += '; HttpOnly'
    if (typeof maxAge !== 'undefined') cookieString += `; max-age=${maxAge}`
    cookieString += `; path=${path ?? '/'}`
    if (sameSite) cookieString += `; samesite=${sameSite}`
    if (!DEV) cookieString += '; Secure'

    document.cookie = cookieString
  },
  get: (name: string): string | null => {
    if (typeof window === 'undefined') return null
    const allCookies = document.cookie.split(';')

    for (const cookie of allCookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=')
      if (cookieName === name) return decodeURIComponent(cookieValue)
    }

    return null
  },
  remove: (name: string) => {
    if (typeof window === 'undefined') return null
    // if(DEV) {
    //   document.cookie = name+'=; Max-Age=-99999999;'
    //   return
    // }

    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Path=/; domain=${getDomain()}`
  }
}


export const getExpiryDate = (): string => {
  const date = new Date()
  date.setHours(date.getHours() + 6)
  return date.toISOString()
}


export const getMaxAge = (dateString: string): number => {
  // Regex to detect if the dateString is in ISO format "YYYY-MM-DDTHH:mm:ssZ" or similar
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(.\d+)?(Z|([+-]\d{2}:\d{2})))?$/

  let isoFormattedString

  if (isoRegex.test(dateString)) {
    // Use as is if already ISO 8601 format
    isoFormattedString = dateString
  } else {
    // Assume dateString is in "MM-DD-YYYY HH:mm" format
    const [datePart, timePart] = dateString.split(' ')
    const [month, day, year] = datePart.split('-')
    isoFormattedString = `${year}-${month}-${day}T${timePart}`
  }

  const date = new Date(isoFormattedString)
  const currentTime = new Date()
  const timeDifferenceMilliseconds = date.getTime() - currentTime.getTime()

  const maxAgeSeconds = Math.floor(timeDifferenceMilliseconds / 1000)
  return maxAgeSeconds
}
